export default __webpack_public_path__ + "static/media/ins_100_men.a3650008.jpg";